/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_ValidatorInputs */



/**
* | output |
* | --- |
* | "Please enter a number greater than or equal to 0" |
*
* @param {Ad_Template_Min_Gap_ValidatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_validator = /** @type {((inputs?: Ad_Template_Min_Gap_ValidatorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_ValidatorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez saisir un nombre supérieur ou égal à 0")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie eine Zahl größer oder gleich 0 ein")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un numero maggiore o uguale a 0")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите число больше или равное 0")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca un número mayor o igual a 0")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入大于或等于0的数字")
	if (locale === "ja") return /** @type {LocalizedString} */ ("0以上の数値を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया 0 या उससे अधिक संख्या दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Introduza um número maior ou igual a 0")
	return /** @type {LocalizedString} */ ("Please enter a number greater than or equal to 0")
});